"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$ambiguousNameParenthesesContent = void 0;
const controls_1 = require("../../../node/el/controls");
const factory_1 = __importDefault(require("../factory"));
exports.$ambiguousNameParenthesesContent = factory_1.default
    .withName("nameInline")
    .sequence(s => s
    .and(r => r
    .zeroOrMore(r => r
    .oneMatch(({ item }) => {
    if (!((item instanceof controls_1.__Text)
        && item.text().includes("をいう。"))) {
        return item;
    }
    else {
        return null;
    }
})), "valueRest")
    .and(r => r
    .choice(c => c
    .orSequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /をいう。以下同じ。$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
}), "valueLast")
    .action(({ valueLast }) => {
    return {
        valueLast,
        following: true,
        pointerRanges: null,
    };
}))
    .orSequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /をいう。(?:以下)?$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
}), "valueLast")
    .and(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.____PointerRanges)) {
        return item;
    }
    else {
        return null;
    }
}), "pointerRanges")
    .andOmit(r => r
    .oneMatch(({ item }) => {
    if ((item instanceof controls_1.__Text)
        && /^において同じ。$/.test(item.text())) {
        return item;
    }
    else {
        return null;
    }
}))
    .action(({ valueLast, pointerRanges }) => {
    return {
        valueLast,
        following: valueLast.text().endsWith("以下"),
        pointerRanges,
    };
}))), "rest")
    .action(({ valueRest, rest }) => {
    const value = {
        valueELs: [...valueRest, rest.valueLast],
        following: rest.following,
        pointerRanges: rest.pointerRanges,
    };
    return { value, errors: [] };
}));
exports.default = exports.$ambiguousNameParenthesesContent;
//# sourceMappingURL=$ambiguousNameParenthesesContent.js.map